<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;" v-if="edit">Edit Vendor</h1>
      <h1 style="color: #AC8400;" v-else>Add Vendor</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link :to="{ name: 'account-view' }">Vendor Account</router-link>
      /
      <b v-if="edit">Edit Vendor</b>
      <b v-else>Add Vendor</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3" v-if="edit">Edit Vendor's Details</h4>
            <h4 class="card-title mb-3" v-else>Enter Vendor's Details</h4>
            <br />
            <div class="row">
              <div class="col-12">
                <label>Company Name</label>
                <input
                  type="text"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="companyName"
                />
                <div v-if="edit">
                  <label>Status</label>
                  <div class="row">
                    <label class="radio radio-success ml-3">
                      <input
                        type="radio"
                        name="radio"
                        v-model="active"
                        v-bind:value="a"
                      />
                      <span>Active</span>
                      <span class="checkmark"></span>
                    </label>
                    <label class="radio radio-danger ml-3">
                      <input
                        type="radio"
                        name="radio"
                        v-model="active"
                        v-bind:value="b"
                      />
                      <span>Inactive</span>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <label>Company Address</label>
                <input
                  type="text"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="companyAddress"
                />
                <label>Company Contact No.</label>
                <input
                  type="text"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="companyContact"
                />
                <label>Company Email</label>
                <input
                  type="text"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="companyEmail"
                />
                <label>Username</label>
                <input
                  type="text"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="username"
                />
                <div v-if="!edit">
                  <label>Password</label>
                  <input
                    type="password"
                    class="form-control"
                    style="margin-bottom: 10px;"
                    v-model="password"
                  />
                  <label>Confirmation Password</label>
                  <input
                    type="password"
                    class="form-control"
                    style="margin-bottom: 10px;"
                    v-model="password_confirmation"
                  />
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <span class="col-4"></span>
                <div v-if="edit">
                  <router-link
                    class="btn btn-primary btn-rounded col-2"
                    :to="generateQr()"
                    >QR Code
                  </router-link>
                  &nbsp;&nbsp;
                  <button
                    class="btn btn-primary btn-rounded col-2"
                    @click="onUpdate()"
                  >
                    Submit
                  </button>
                </div>

                <button
                  v-else
                  class="btn btn-primary btn-rounded col-2"
                  @click="onSubmit()"
                >
                  Submit
                </button>
                <span class="col-4"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div v-if="edit">
                  <hr />
                  <label>Password</label>
                  <input
                    type="password"
                    class="form-control"
                    style="margin-bottom: 10px;"
                    v-model="password"
                  />
                  <label>Confirmation Password</label>
                  <input
                    type="password"
                    class="form-control"
                    style="margin-bottom: 10px;"
                    v-model="password_confirmation"
                  />
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <span class="col-4"></span>
                <button
                  v-if="edit"
                  class="btn btn-primary btn-rounded col-2"
                  @click="updatePassword()"
                >
                  Change Password
                </button>
                <span class="col-4"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "account-add",
  mixins: [dateManipulation],
  props: ["edit"],
  components: { vSelect },

  data() {
    return {
      user_id: "",
      companyName: "",
      companyAddress: "",
      companyContact: "",
      companyEmail: "",
      username: "",
      password: "",
      password_confirmation: "",
      active: 0,
      a: 1,
      b: 0
    };
  },

  computed: {
    checkEdit() {
      if (this.$props.edit) {
        return true;
      }
      return false;
    }
  },

  methods: {
    // Load Details
    async loadDetails() {
      if (!this.$props.edit) {
        return;
      }
      let id = this.$route.params.id;
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(axios.lpsURL + "/vendor/getOne/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.user_id = result.data.user.id;
          this.companyName = result.data.name;
          this.companyAddress = result.data.address;
          this.companyContact = result.data.user.mobile_number;
          this.companyEmail = result.data.user.email;
          this.username = result.data.user.username;
          this.active = result.data.user.active;
        } catch (error) {
          console.log(error);
        }
      }
    },

    //CheckAPI
    getURL() {
      if (this.$props.edit) {
        return "/vendor/update/";
      } else {
        return "/vendor/store";
      }
    },

    onUpdate() {
      if (!this.checkToken()) {
        return;
      }
      let id = this.$route.params.id;
      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        axios
          .post(
            axios.lpsURL + "/vendor/update/" + id,
            {
              name: this.companyName,
              address: this.companyAddress,
              email: this.companyEmail,
              mobile_number: this.companyContact,
              active: this.active,
              username: this.username
            },
            {
              headers: {
                Authorization: "Bearer " + this.checkToken()
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              }).then(() => {
                if (!this.edit) {
                  this.$router.push("edit/" + res.data.survey_id);
                }
              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    onSubmit() {
      let token = this.checkToken();
      let apiUrl = this.getURL();

      if (this.$props.edit) {
        let id = this.$route.params.id;
        apiUrl = this.getURL() + id;
      }

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }

        axios
          .post(
            axios.lpsURL + apiUrl,
            {
              name: this.companyName,
              address: this.companyAddress,
              username: this.username,
              email: this.companyEmail,
              password: this.password,
              password_confirmation: this.password_confirmation,
              mobile_number: this.companyContact,
              active: this.active
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              }).then(() => {
                if (!this.edit) {
                  this.$router.push("edit/" + res.data.vendor_id);
                }
              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    updatePassword() {
      if (!this.checkToken()) {
        return;
      }

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        axios
          .post(
            axios.lpsURL + "/vendor/update_password/" + this.user_id,
            {
              password: this.password,
              password_confirmation: this.password_confirmation
            },
            {
              headers: {
                Authorization: "Bearer " + this.checkToken()
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    generateQr() {
      let id = this.$route.params.id;
      return "/qrcode?user=" + id;
    },

    // Check Token
    checkToken() {
      let token = localStorage.getItem("token");
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;
        return token;
      }
      return false;
    }
  },

  async created() {
    await this.loadDetails();
  },

  mounted() {}
};
</script>
